import { BackgroundCheckAnalytics } from '@/backend/features/background-check';
import { BackgroundCheckQuota } from '@/backend/features/background-check/defaults';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Box, Stack, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface BackgroundCheckSummaryHeadingProps {
    analytics: BackgroundCheckAnalytics;
    quota?: BackgroundCheckQuota;
}

export const BackgroundCheckSummaryHeading: React.FC<BackgroundCheckSummaryHeadingProps> = ({ analytics, quota }) => {
    const { t } = useTranslation();
    const quotaLeft = quota ? Number(quota[analytics.type]?.quota) - Number(analytics.quotaUsed) : null;

    return (
        <Stack direction='row' sx={{ p: 2, justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant='subtitle2'>{t(`pages.screenings.backgroundChecks.${analytics.type}`)}</Typography>
            {quota && quota[analytics.type]?.enabled && analytics.isJasSearch && (
                <Box sx={{ display: 'inline-flex', gap: 0.5 }} data-test='total-submitted-content'>
                    <Typography variant='body2'>
                        {t('pages.screenings.backgroundChecks.totalSubmitted', { quantity: analytics.totalSubmitted })}
                    </Typography>
                    <Typography variant='body2' color={themeColors.accent.red.bold}>
                        {t('pages.screenings.backgroundChecks.quotaLeft', { quotaLeft: quotaLeft })}
                    </Typography>
                </Box>
            )}
        </Stack>
    );
};
